import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
type Props = {
	onClick: () => void;
};

const TriggerShowDetailsButton = ({onClick}: Props) => {
	return (
		<a onClick={onClick}>
			<Trans i18nKey="ruleengine.edit.rule.showTriggerDetails">Trigger Details</Trans>
		</a>
	);
};

export default TriggerShowDetailsButton;
